const onlyNumbers = (str) => {
    if (str !== undefined && str !== null){
      return String(str).replace(/\D+/g, '');
    } else {
      return ""
    }  
  }
  
  export default onlyNumbers;